/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import './Conteudo.css';

const Conteudo = () => {
    return(
        <>
            {/* Alice Solicitou a retirada dessa parte do código 
            <section className="conteudocard">

                 <div class="card">
                
                    <div class="container">
                    <h2><b>PÚBLICO ALVO</b></h2>
                    <p>Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer v Architect & Engineer</p>
                </div>
                </div>
            
                 <div class="card2">
                    <div class="container">
                    <h2><b>DIFERENCIAS</b></h2>
                    <p>Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer</p>
                </div>
                </div>

                 <div class="card3">
                    <div class="container">
                    <h2><b>MATRIZ</b></h2>
                    <p>Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer Architect & Engineer</p>
                </div>
                </div>
           
            </section> 
            */}

            <section  className="conteudoencontro">

                <div className="encontro" id="encontro-home">
                    <img src="encontros.png" className="desktopencontros" id="mobile-encontros" alt="encontros"></img>
                    {/* <h3>ENCONTROS</h3> */}
                    <p>MENSALMENTE | QUARTA A SÁBADO</p>
                {/* Alice Solicitou a retirada dessa parte do código  
                <p>8H ÀS 12H E DAS 13H30 DAS 17H30</p> 
                */}
                </div>
                {/* Alice Solicitou a retirada dessa parte do código 
                <div className="cargahoraria">
                <h3>CARGA HORÁRIA</h3>
                <p>+800 HORAS</p>
                </div> 
                */}
                <div className="tipodeaula">
                    <img src="tipodeaula.png" className="desktop-tipodeaula" id="mobile-tipodeaula" alt="tipodeaula"></img>
                    {/* <h3>TIPO DE AULA</h3> */}
                    <p>PRESENCIAL</p>
                </div>

            </section>
        </>
    )
}

export default Conteudo;